<c-container class="mt-5">
  <h2>Testing Area</h2>
  <app-choose-your-game [message]="'Choose a game to start some testing'" (gameChosenEvent)="onGameChange($event)"></app-choose-your-game>
  @if(activeGame) {

    <c-row class="mb-3">
      <c-col md="3" class="mb-3">
        <div cListGroup>
          <button cListGroupItem
                  data-testid="test-emails-tab"
                  (click)="currentScreenState = screenState.SendEmails"
                  [active]="currentScreenState === screenState.SendEmails">
            <div>
              <h5 class="mb-1">Test Emails</h5>
              <p>Send yourself emails to ensure formatting and styling is correct</p>
            </div>
          </button>

          <button cListGroupItem
                  data-testid="test-sentry-tab"
                  (click)="currentScreenState = screenState.SendSentryError"
                  [active]="currentScreenState === screenState.SendSentryError">
            <div>
              <h5 class="mb-1">Test Sentry Exception</h5>
              <p>Send a Sentry exception to test that the configuration is working</p>
            </div>
          </button>
        </div>
      </c-col>

      <c-col>
        @switch (currentScreenState) {
          @case (screenState.SendEmails) {
            @if (uiState === uiStateEnumForTemplate.ShowData) {
            <form [formGroup]="emailForm">
              <mat-form-field appearance="outline" class="flex-66 full-width">
                <mat-select formControlName="template" multiple (selectionChange)="onSelect($event)" placeholder="All">
                  <mat-option>All</mat-option>
                  @for (emailTemplate of emailTemplateTypes; track emailTemplate.Value) {
                    <mat-option [value]="emailTemplate.Value">{{ emailTemplate.Name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </form>

            <button mat-raised-button (click)="generateTestEmails()">Generate Emails</button>
            } @else {
              <mat-spinner class="align-center"></mat-spinner>
            }
          }
          @case (screenState.SendSentryError) {
            <button mat-raised-button (click)="testSentryException()">Causable API - Test Sentry Exception</button>
          }
        }
      </c-col>
    </c-row>
  }

</c-container>

